import React, { Component } from 'react'
import firebase, { auth } from './firebase'
import InputMask from 'react-input-mask';
import axios from 'axios'
import {firebase_url} from './config'
import './profile.css'

class Profile extends Component {
  state = {
    loader: true,
    user: null,
    email: '',
    display_name: '',
		first_name: '',
		last_name: '',
    ptin: '',
		phone_number: '',
    saving: false,
    save_status: null,
		save_status_message: '',
  }
  componentWillMount = () => {
    auth.onAuthStateChanged(user => {
      if (user) {
        var db = firebase.database();
        db.ref('users/' + user.uid).once('value').then(snap => {
          this.setState({user: user, email: user.email, display_name: snap.val().first_name + ' ' + snap.val().last_name, ptin: snap.val().ptin, loader: false, first_name: snap.val().first_name, last_name: snap.val().last_name, phone_number: user.phoneNumber || '+18018888888'})
        })
      } else {
        console.log('not logged in')
        //TODO handle if user is not logged in state
        //this.setState({loader: false})
      }
    })
  }
	validatePTIN = (ptin) => {
    return ptin.match(/^[P|p][0-9]{8}$/);
  }
	sendResetPasswordEmail = () => {
		var user = firebase.auth().currentUser;
		axios.get(`${firebase_url}/registerAndLogin/forgot-password?email=${encodeURI(btoa(user.email))}`)
		.then(res => {
			if ('success' in res.data && res.data.success) {
				localStorage.setItem('last_submitted_email', this.state.email)
				this.setState({redirect: true})
			} else if ('errorMessage' in res.data) {
				this.setState({
					errorMessage: res.data.errorMessage,
					errorCode: res.data.errorCode
				})
			}
		}).catch(error => {
			this.setState({
				errorMessage: error.message,
				errorCode: error.code
			})
		})
	}
  handleSubmit = event => {
    event.preventDefault();
		if (!this.validatePTIN(this.state.ptin)) {
			this.setState({save_status: 'error', save_status_message: 'All PTINs must begin with a "P", followed by eight numbers, with no hyphens or spaces.'})
		} else {
	    this.setState({saving: true, save_status: 'pending'})
	    var db = firebase.database();
			var updateData = {}
			if (this.state.ptin) {
				updateData['ptin'] = this.state.ptin
			}
			updateData['first_name'] = this.state.first_name
			updateData['last_name'] = this.state.last_name
	    db.ref('users').child(this.state.user.uid).update(updateData)
			.then(() => {
				var user = firebase.auth().currentUser;
				// var newPhone = '+' + this.state.phone_number.replace(/\D/g,'')
				return user.getIdToken(true).then(token => {
					var AuthStr = 'Bearer '.concat(token)
					var data = {phone_number: this.state.phone_number}
					var config = {headers: {Authorization: AuthStr}}
						return axios.post(`${firebase_url}/registerAndLogin/updatePhone`, data, config).then(res => {
							console.log(res.data)
						})
					})
				// return user.updateProfile({phoneNumber: newPhone}).then(() => {console.log('k')})
			}).then(() => {
	      this.setState({saving:false, save_status: 'success'})
	    }).catch(error => {
				console.log('error:', error)
	      this.setState({save_status: 'error', save_status_message: 'Unable to save: ' + error.message, saving: false})
	    })
		}
  }
  render() {
    if (this.state.loader) {
      return <div className="loginBox"><div className="large-loader"></div></div>
    }
    return <div className="profile">
      <section id="form-container">
        <a href="https://opencourse.canopytax.com/account/certificates">Back</a>
        <form action={this.handleSubmit}>
          <h1 id="form-title"> Account Settings </h1>
          <input type="text" placeholder="Email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} disabled/>
          <input type="text" placeholder="First Name" value={this.state.first_name} onChange={e => this.setState({first_name: e.target.value})}/>
					<input type="text" placeholder="Last Name" value={this.state.last_name} onChange={e => this.setState({last_name: e.target.value})}/>
					<InputMask mask="+1 (999) 999-9999" maskChar=" " placeholder="Phone Number" value={this.state.phone_number} onChange={e => this.setState({phone_number: e.target.value})}/>
          <input type="text" placeholder="PTIN" value={this.state.ptin} onChange={e => this.setState({ptin: e.target.value})}/>
          <button id="save_profile" className={this.state.saving ? 'button-saving' : ''} disabled={this.state.saving} onClick={this.handleSubmit}>Save</button>
        {
          (this.state.save_status === 'pending') ? <div className="save_temp_message">Saving...</div> : ''
        }
        {
          (this.state.save_status === 'success') ? <div className="save_temp_message">Saved</div> : ''
        }
        {
          (this.state.save_status === 'error') ? <div className="save_temp_message_error">{this.state.save_status_message}</div> : ''
        }

        </form>
      </section>
      </div>
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/profile.js